import { getActiveTenantKey, getTenantScopedKey } from '../../offline/tenant'

// Crew Mode Field Bundle v0 §3 item 7: a sampling round is kept on the device,
// per operator and lot, until "Terminar ronda" — so leaving the screen,
// locking the phone or reloading does not lose the listed readings. Two
// operators on one phone keep separate rounds (§10).

export type StoredRoundEntry = {
  weightSampleLogId: string
  weightLabel: string
  lengthLabel: string | null
  recordedAt?: string
  state: 'local' | 'pending' | 'synced' | 'error'
}

type RoundKey = { farmId: string; lotId: string; operatorActorId: string }

const keyFor = (round: RoundKey): string =>
  getTenantScopedKey(
    `crewModeWeightRound:${round.farmId}:${round.lotId}:${round.operatorActorId || 'anon'}`,
    getActiveTenantKey()
  )

const storage = (): Storage | null => {
  try {
    return globalThis.window?.localStorage ?? null
  } catch {
    return null
  }
}

const isEntry = (value: unknown): value is StoredRoundEntry => {
  if (!value || typeof value !== 'object') return false
  const entry = value as Record<string, unknown>
  return typeof entry.weightSampleLogId === 'string' && typeof entry.weightLabel === 'string'
}

export const readStoredRound = (round: RoundKey): StoredRoundEntry[] => {
  const store = storage()
  if (!store || !round.farmId || !round.lotId) return []
  try {
    const parsed = JSON.parse(store.getItem(keyFor(round)) ?? '[]') as unknown
    return Array.isArray(parsed) ? parsed.filter(isEntry) : []
  } catch {
    return []
  }
}

export const writeStoredRound = (round: RoundKey, entries: StoredRoundEntry[]): void => {
  const store = storage()
  if (!store || !round.farmId || !round.lotId) return
  try {
    if (entries.length === 0) store.removeItem(keyFor(round))
    else store.setItem(keyFor(round), JSON.stringify(entries))
  } catch {
    // the readings themselves are saved; only the on-screen list is lost
  }
}

export const clearStoredRound = (round: RoundKey): void => writeStoredRound(round, [])
